require('./facts-menu.component.scss');

class FactsMenuController {
  constructor(CurrentFilterService, RouterService, PermissionService) {
    this.CurrentFilterService = CurrentFilterService;
    this.router = RouterService;
    this.permission = PermissionService;
  }

  setMode(mode) {
    if (this.isFilterEdit && this.filterData) this.filterData.filter.mode = mode;
    else this.router.mode = mode;
  }

  get isFilterEdit(){
    return this.router.isFilterEditModal;
  }

  setListType(listType) {
    if (this.isFilterEdit && this.filterData) this.filterData.filter.listType = listType;
    else this.router.listType = listType;
  }

  get filter() {
    // return this.CurrentFilterService.filter;
    return this.isFilterEdit && this.filterData ? this.filterData.filter : this.CurrentFilterService.filter;
  }
}

export const FactsMenuComponent = {
  template: require('./facts-menu.component.html'),
  bindings: {
    filterData: '<',
  },
  controller: FactsMenuController,
};



// WEBPACK FOOTER //
// ./src/facts/facts-menu.component.js